import { render } from "./ComoSePuntuaCircuito.vue?vue&type=template&id=1df2d6db&scoped=true"
const script = {}

import "./ComoSePuntuaCircuito.vue?vue&type=style&index=0&id=1df2d6db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df2d6db"]])

export default __exports__